// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__28Imb","row":"ProcedureTreatmentSummary_row__3s7ls"};